import { enumDocumentType } from '@rematter/frontend-lib-api-client';

export const purchaseOrderDocuments = [
  {
    label: 'Sales Order',
    documentType: enumDocumentType.SalesOrder,
  },
];

export const bookingDocuments = [
  {
    label: 'Invoice',
    documentType: enumDocumentType.Invoice,
  },
];

export const loadDocuments = [
  {
    label: 'Bill of Lading',
    documentType: enumDocumentType.BillOfLading,
  },
  {
    label: 'Packing List',
    documentType: enumDocumentType.PackingList,
  },
];
